// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const TickIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 1 24 24"><path d="M7.207 12.793a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l6-6a1 1 0 10-1.414-1.414L9.5 15.086l-2.293-2.293z" fill="currentColor"/></svg>'} />;

(TickIcon as any).displayName = 'TickIcon';

export default TickIcon;
